module.exports = __webpack_public_path__ + "media/theme/og-7bb4054b.png";